module.exports = __webpack_public_path__ + "static/media/success-icon.7d066d74.svg";